module.exports = __webpack_public_path__ + "img/T6-D-xh_18.8fe89869.png";